import moment from 'moment';

import {
  viewsSelector,
  contentTypeSelector
  // typeAppSelector
} from './types';

export const getRandomKey = () => Math.round(Math.random() * 999999);

export const validateData = (name, value) => {
  switch (name) {
    case 'title':
      return value.search(/[0-9]/) === -1 && value !== '';
    case 'date':
      return moment(value).toDate() instanceof Date;
    case 'contentType':
      return value.search(/[0-9]/) === -1;
    // case 'typeApp':
    // return value.search(/[0-9]/) === -1;
    case 'viewed':
      return typeof value === 'boolean';
    default:
      return false;
  }
};

export const findFilters = () => {
  if (this.inputFields) {
    this.inputFields.some(el => el.value !== '' && el.value !== undefined);
    return true;
  }
  return false;
};

export const getSelectorTextByFilter = (selector, value) =>
  selector.find(v => v.value === value).text || undefined;

export const getSelectorByFilter = (selector, value) =>
  selector.find(v => v.value === value) || undefined;

export const getLabel = (state, filter, type) => {
  let result = 'Seleccionar opción';
  let selector;
  let value;
  if (state && state[type] !== undefined) {
    value = state[type];
  } else if (filter && filter[type] !== undefined) {
    value = filter[type];
  }
  switch (type) {
    case 'viewed':
      selector = viewsSelector;
      break;
    // case 'typeApp':
    // selector = typeAppSelector;
    // break;
    case 'contentType':
      selector = contentTypeSelector;
      break;
    default:
      selector = undefined;
  }
  if (selector !== undefined && value !== undefined) {
    result = getSelectorTextByFilter(selector, value);
  }
  return result;
};
